import slick from '../modules/slick';
import tabslet from '../modules/tabslet';

export default () => {
  let $articlesTabs = $('.articles__tabs');

  let $articleSlider = $('.articles__slider_pre-article');
  let $newsSlider = $('.articles__slider_news');

  if ($articlesTabs.length) {
    // if (  window.location.pathname === '/' ){
    //     tabslet($articlesTabs, {
    //         mouseevent: 'click',
    //         attribute: 'href',
    //         animation: true,
    //         active: 1,
    //         container: '.articles__tabs-container'
    //     });
    // }
    $articlesTabs.on("_after", function (e) {
      let tabName = $(e.target).find('.articles__tabs-link').attr('href');
      if (tabName === '#tabs-articles') {
        $articleSlider.slick('setPosition', 0);
        $articleSlider.animate({opacity: 1});
      }
    });
  }

  if ($articleSlider.length) {

    if (window.location.pathname.includes('stati')) {
      $articleSlider.on('init', function () {
        $articleSlider.animate({opacity: 1});
      });
    }

    slick($articleSlider, {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: false,
      rows: 2,
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            verticalSwiping: true,
            vertical: true,
          }
        }
      ],
      // appendArrows: '.slide-count'
      prevArrow: '#tabs-articles .articles__arrow_back',
      nextArrow: '#tabs-articles .articles__arrow_next'
    });
  }

  if ($newsSlider.length) {
    $newsSlider.on('init', function () {
      $newsSlider.animate({opacity: 1});
    });

    slick($newsSlider, {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: false,
      rows: 2,
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            verticalSwiping: true,
            vertical: true,
          }
        }
      ],
      // appendArrows: '.slide-count'
      prevArrow: '#tabs-news .articles__arrow_back',
      nextArrow: '#tabs-news .articles__arrow_next'
    });
  }

};



// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/articles.js